import * as tslib_1 from "tslib";
import { BlendMode } from "@awayjs/graphics";
import { BasicMaterialPass } from "./passes/BasicMaterialPass";
import { GL_MaterialBase } from "./GL_MaterialBase";
/**
 * RenderMaterialObject forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var GL_BasicMaterial = (function (_super) {
    tslib_1.__extends(GL_BasicMaterial, _super);
    function GL_BasicMaterial(material, materialPool) {
        var _this = _super.call(this, material, materialPool) || this;
        _this._basicMaterial = material;
        _this._pAddPass(_this._pass = new BasicMaterialPass(_this, materialPool));
        return _this;
    }
    GL_BasicMaterial.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._basicMaterial = null;
    };
    /**
     * @inheritDoc
     */
    GL_BasicMaterial.prototype._pUpdateRender = function () {
        _super.prototype._pUpdateRender.call(this);
        this._pRequiresBlending = (this._basicMaterial.blendMode != BlendMode.NORMAL || this._basicMaterial.alphaBlending || (this._basicMaterial.colorTransform && this._basicMaterial.colorTransform.alphaMultiplier < 1));
        this._pass.preserveAlpha = this._basicMaterial.preserveAlpha; //this._pRequiresBlending;
        this._pass.shader.setBlendMode((this._basicMaterial.blendMode == BlendMode.NORMAL && this._pRequiresBlending) ? BlendMode.LAYER : this._basicMaterial.blendMode);
        //this._pass.forceSeparateMVP = false;
    };
    return GL_BasicMaterial;
}(GL_MaterialBase));
export { GL_BasicMaterial };



// WEBPACK FOOTER //
// ../dist/lib/materials/GL_BasicMaterial.js